import {
  MutableColumnDetails,
  StaticColumnDetails,
} from '../../../jobs/infra/JobsTableColumns'
import { TableHeader, TableSortOrder } from '../../../components/Table'
import { observer } from 'mobx-react'
import React from 'react'
import JobsTableColumnManager from '../../../jobs/infra/JobsTableColumnManager'
import { jobTableColumnStyles } from '../../../jobs/views/JobManagement/JobsTable'

interface Props {
  vm: JobsTableColumnManager
  getSortOrder: (
    column: StaticColumnDetails & MutableColumnDetails,
  ) => TableSortOrder
  setSortOrder: (
    column: StaticColumnDetails & MutableColumnDetails,
    direction: TableSortOrder,
  ) => void
}

export default observer(({ vm, getSortOrder, setSortOrder }: Props) => (
  <>
    {vm.filteredColumns
      .filter((col) => col.visible)
      .map((col) => (
        <TableHeader
          key={col.id}
          className={jobTableColumnStyles[col.header]}
          canSort={col.sortable}
          align="left"
          sortOrder={getSortOrder(col)}
          onSort={(newSort) => {
            setSortOrder(col, newSort)
          }}
        >
          {col.header}
        </TableHeader>
      ))}
  </>
))
